import axios from 'axios'
import { Toast } from 'vant'
import { SERVER_URL, TOKEN_NAME, X_ADDR } from '@/constant/config'

const instance = axios.create({
  baseURL: SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-addr': X_ADDR
  },
  timeout: 20000
})

// 拦截器
instance.interceptors.request.use(config => {
  const userInfo = JSON.parse(localStorage.getItem(TOKEN_NAME))
  if (userInfo) {
    config.headers['x-token'] = userInfo.Token
  }
  return config
}, err => {
  console.log(err)
})

instance.interceptors.response.use(({ config, data }) => {
  return new Promise((resolve, reject) => {
    // console.log('config = ', config)
    if (config.interceptors === false) {
      return resolve(data)
    } else {
      // 请求通过
      if (data.code === 0) {
        return resolve(data)
      }
      // 请求出错 提示错误信息
      if (data.code === 200) {
        localStorage.removeItem(TOKEN_NAME)
      }
      if (config.errorMessage !== false) {
        Toast(data.msg)
      }
      return reject(data)
    }
  })
}, (err) => {
  console.log(JSON.stringify(err))
  return Promise.reject(err)
})

export default instance
